import {Controller} from "stimulus"
import Choices from "choices.js"

/**
 * Form bone de recharge
 */
export default class extends Controller {

    static targets = [
    ]

    initialize() {
        const choices = new Choices(this.element, {})
    }

}
